module.exports = __webpack_public_path__ + "static/media/image.969fdf47.svg";